// extracted by mini-css-extract-plugin
export var loader = "Loader-module--loader--2jMxZ";
export var animateOut = "Loader-module--animateOut--1E925";
export var loaderCircle = "Loader-module--loaderCircle--R9NBX";
export var animateIn = "Loader-module--animateIn--3DcPL";
export var startRotation = "Loader-module--startRotation--3JeU9";
export var rotation = "Loader-module--rotation--3gKrA";
export var rays = "Loader-module--rays--3PDwR";
export var raySouth = "Loader-module--raySouth--2Vtbt";
export var rayEast = "Loader-module--rayEast--1A9p6";
export var rayWest = "Loader-module--rayWest--2CJMP";
export var rayNorth = "Loader-module--rayNorth--2PQLZ";
export var ray = "Loader-module--ray--UNXrM";